import { useEffect, useState } from 'react'
import { CustomerRewards } from 'shared-types'
import { useSession } from '~/hooks'
import { Client } from '~/customClients/client'

export function useCustomerRewards(
  source?: string,
  isDrawerOpen = false,
  isDisabled = false
) {
  const { session } = useSession()
  const [customerRewards, setCustomerRewards] =
    useState<CustomerRewards | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  useEffect(() => {
    const fetchRewards = async () => {
      if (!session?.token?.isLoggedIn && !session?.token?.customerId) {
        return null
      }

      if (
        isDisabled ||
        (source === 'AccountQuickViewDrawer' && !isDrawerOpen)
      ) {
        return null
      }

      try {
        setIsLoading(true)
        const response = await Client.account.getLoyaltyPoints(session)
        setCustomerRewards(response.getValue())
      } finally {
        setIsLoading(false)
      }
    }

    fetchRewards()
  }, [isDrawerOpen, session, source, isDisabled])

  return {
    customerRewards,
    isLoading,
  }
}
